import { z } from 'zod';
import { timestampSchema } from './shared';

export const contactMessageRowSchema = z.object({
  id: z.string().min(1),
  leadId: z.string().min(1),
  body: z.string(),
  createdAt: timestampSchema,
});

export type ContactMessageRow = z.infer<typeof contactMessageRowSchema>;
